import request from '@/utils/request'

export function queryAnnualContractFundStatistics (query) {
  return request({
    url: '/crmContractFinance/annualContractFundStatistics',
    method: 'get',
    params: query
  })
}

export function queryReceivableLedger (query) {
  return request({
    url: '/crmContractFinance/receivableLedger',
    method: 'get',
    params: query
  })
}

export function saveReceivableLedgerMeta (data) {
  return request({
    url: '/crmContractFinance/receivableLedger/meta',
    method: 'put',
    data
  })
}
